// extracted by mini-css-extract-plugin
module.exports = {"root":"JmmqNrGT0BVAe8DIwvQW"};